export const ShippingMethod: Record<string, string | number> = {
  OBJECT_TYPE_CODE: 10089,
  NAME: 'tog_shippingmethod',
  ALL_SHIPMENTS: 'all-shipments',
  UPS: 100000000,
  FEDEX: 100000001,
  CUSTOMER_PICKUP: 100000002,
  TOG_DELIVERY: 100000003,
  COURIER: 100000004,
  EXPORT: 100000005,
  CUSTOMER_PICKUP_GAC: 100000006,
  EXPORTS_COURIER: 100000007,
  DISCARD: 100000008,
};

export const LocationValue: Record<string, string> = {
  ALL_LOCATIONS: 'all-locations',
  IOWA: '8e229164-4c97-de11-8de3-0019d18a6560',
  MO: '7af40e6b-4c97-de11-8de3-0019d18a6560',
};

export enum ShippingMethodValue {
  ALL_SHIPMENTS = 'all-shipments',
  UPS = 'ups',
  FEDEX = 'fedex',
  CUSTOMER_PICKUP = 'customer-pickup',
  TOG_DELIVERY = 'tog-delivery',
  COURIER = 'courier',
  EXPORT = 'export',
  CUSTOMER_PICKUP_GAC = 'customer-pickup-gac',
  EXPORTS_COURIER = 'exports-courier',
  ACTIVE_SHIPMENTS = 'active-shipments',
}

export const ShippingMethodTitle: Record<string, string> = {
  'all-shipments': 'All Shipments',
  ups: 'UPS',
  fedex: 'FedEx',
  'customer-pickup': 'Customer Pickup',
  'tog-delivery': 'TOG Delivery',
  courier: 'Courier',
  export: 'Export',
  'customer-pickup-gac': 'Customer Pick-Up GAC',
  'exports-courier': 'Exports / Courier',
};

export const ShipmentStatus: Record<string, string | number> = {
  OBJECT_TYPE_CODE: 10090,
  NAME: 'tog_shpmentstatus',
  SHIPPED: 100000000,
  SCHEDULED: 100000001,
  IN_PROGRESS: 100000002,
  TRANSFER_TRIP: 100000003,
  IA_IN_CLINIC_FROZENS: 100000004,
  MTO_CLIENT_ENTRY: 100000005,
  MTO_TOG_CLIENT_REVIEW: 100000006,
  INCOMPLETE: 100000007,
  /* TODO: Move to CSS with standardized color system. */
  IN_PROGRESS_COLOR: 'shipping__in-progress-row',
};

export enum ShipFromSiteId {
  IOWA = '8E229164-4C97-DE11-8DE3-0019D18A6560',
  WISCONSIN = '0F238C3A-1500-E111-9534-000C2936192C',
}
